"use client";

import styled from "styled-components";
import NotFoundSVG from "../svgs/notfound";
import Image from "../image";

export const BoxNotFound = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  background: var(--backgroundColor);
  padding: 0 15px;
`;

export const BoxContentNotFound = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: auto;
`;

export const ImageComponent = styled(Image)`
  max-width: 50px;
  margin-bottom: 20px;
`;

export const NotfoundIcon = styled(NotFoundSVG)`
  width: 100%;
  max-width: 300px;
  height: fit-content;
`;

export const TitleFound = styled.h1`
  font-family: "BlinkMacSystemFont";
  font-size: 90px;
  line-height: 90px;
  color: var(--colorTitle);
  margin-bottom: 0;

  @media (min-width: 768px) {
    font-size: 100px;
  }
`;

export const Descirption = styled.p`
  font-family: "BlinkMacSystemFont";
  font-size: 30px;
  color: var(--colorTitle);
  lien-height: 30px;
  margin-bottom: 15px;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 30px;
  }
`;

export const SmallDescirption = styled.p`
  font-family: "Inter Normal";
  font-size: 16px;
  max-width: 650px;
  text-align: center;
  color: var(--textLight);
  margin-bottom: 20px;
`;

export const Link = styled.a``;

export const BackToHomeButton = styled.a`
  font-family: "Roboto Medium";
  font-size: 15px;
  background: var(--primarySystem100);
  padding: 0.5rem 1rem;
  color: var(--white);
  cursor: pointer;
  transition: 0.3s ease-out;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: calc(0.625rem - 2px);
  color: #fff;
  background: var(--primarySystem100);
  color: var(--white);

  &:hover {
    background: var(--primarySystem500);
  }
`;
